import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-back-button',
  standalone: false,
  template: `
    <button class="btn px-2" type="button" aria-label="Go back" (click)="goBack()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="me-0"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M5 12l4 4" />
        <path d="M5 12l4 -4" />
      </svg>
    </button>
  `,
})
export class PageBackButtonComponent {
  @Input() fallbackRoute: string | unknown[] | null = null;

  constructor(
    private readonly location: Location,
    private readonly router: Router,
  ) {}

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }

    if (Array.isArray(this.fallbackRoute)) {
      void this.router.navigate(this.fallbackRoute as never[]);
      return;
    }

    if (typeof this.fallbackRoute === 'string' && this.fallbackRoute.length > 0) {
      void this.router.navigateByUrl(this.fallbackRoute);
    }
  }
}
